import { NoteButton, WhatsAppButton } from "../Button";
import { useAppSelector } from "../../store";
import { useParams } from "react-router-dom";
import { UserProfileForm } from "./UserProfileForm/UserProfileForm";
import { selectGetUserResult, selectUserStatus } from "../../libs/user/selectors";
import { getIsNoteNew } from "../../libs/user/utils";
import { useQuery } from "../../libs/utils/hooks";
import { NoteModal } from "./NoteModal";
import { useState } from "react";
import { selectPTHasNewMessages } from "../../libs/user/slice";

export const UserInfoSection: React.FC = () => {
  const { id: userId } = useParams();

  const user = useAppSelector((state) => selectGetUserResult(state, userId));
  const status = useAppSelector((state) => selectUserStatus(state, userId || ""));

  const query = useQuery();
  const isShowNoteFromQS = query.get("showNote");
  const [openNoteModal, setNoteOpenModal] = useState<boolean>(
    !!isShowNoteFromQS
  );

  const isUserNoteNew = useAppSelector(selectPTHasNewMessages);

  const isActive = !status || (status + "").toUpperCase() !== "DISABLED";

  return (
    <section>
      <div className="py-6">
        {/* ── Header ── */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          {/* Left: Name + status */}
          <div className="flex items-center gap-4">
            {/* Avatar circle with initials */}
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
              <span className="text-lg font-bold text-blue-600 dark:text-blue-400">
                {(user?.name?.[0] ?? "").toUpperCase()}
                {(user?.surname?.[0] ?? "").toUpperCase()}
              </span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900 dark:text-white leading-tight">
                {user?.name} {user?.surname}
              </h1>
              <div className="flex items-center gap-2 mt-0.5">
                <span
                  className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                    isActive
                      ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400"
                      : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400"
                  }`}
                >
                  <span
                    className={`w-1.5 h-1.5 rounded-full mr-1 ${
                      isActive ? "bg-green-500" : "bg-red-500"
                    }`}
                  />
                  {isActive ? "Attivo" : "Disabilitato"}
                </span>
              </div>
            </div>
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-3">
            {user?.token && (
              <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                <span className="text-xs text-gray-400 dark:text-gray-500">
                  Token:
                </span>
                <span className="text-xs font-mono text-gray-600 dark:text-gray-300">
                  {user.token}
                </span>
                {user.phoneNumber && (
                  <WhatsAppButton
                    tel={user.phoneNumber}
                    message={
                      "Iscriviti ed inserisci questo codice: " + user.token
                    }
                    bgColor={"transparent"}
                  />
                )}
              </div>
            )}
            <NoteButton
              onClick={() => setNoteOpenModal(true)}
              isActive={isUserNoteNew}
            />
          </div>
        </div>

        {/* ── Profile form ── */}
        <UserProfileForm />
      </div>

      <NoteModal
        isModalOpen={!!openNoteModal}
        setOpenModal={setNoteOpenModal}
      />
    </section>
  );
};
